import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.form = this.element;
    }

    disconnect() {
        super.disconnect();
    }
}
